<template>
  <div class="wrapper">
    <b-container fluid style="max-width: 100%">
      <b-row>
        <!-- <b-col class="facilityselector-distancer" lg="1"></b-col> -->
        <b-col class="align-self-center">
          <h1 style="float: left">
            Folgende Liegenschaften sind bereits Teil der Gruppe
          </h1>
          <div class="facility-container" style="float: left">
            <facility-list-item
              v-for="(facility, index) in memberOf"
              :key="'member_' + index"
              :facility="facility"
              @highlight="facility = $event"
            ></facility-list-item>
          </div>
        </b-col>
        <b-col class="align-self-center btn-middle-div">
          <div class="fs-memberof">
            <b-button
              class="m-2"
              block
              variant="secondary"
              id="add"
              @click="addSelected"
              >&lt;</b-button
            >
            <b-button
              class="m-2"
              block
              variant="secondary"
              id="addAll"
              @click="addAll"
              >&lt;&lt;</b-button
            >
            <b-button
              class="m-2"
              block
              variant="secondary"
              id="removeAll"
              @click="removeAll"
              >&gt;&gt;</b-button
            >
            <b-button
              class="m-2"
              block
              variant="secondary"
              id="remove"
              @click="removeSelected"
              >&gt;</b-button
            >
          </div>
        </b-col>
        <b-col class="align-self-center">
          <h1 style="float: right">
            Folgende Liegenschaften stehen noch zur Auswahl
          </h1>
          <div class="facility-container" style="float: right">
            <facility-list-item
              v-for="(facility, index) in available"
              :key="'available_' + index"
              :facility="facility"
              @highlight="facility = $event"
            ></facility-list-item>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FacilityListItem from "./FacilityListItem";

import { mapGetters } from "vuex";

import businessgroupMixin from "../mixins/businessgroupmixin";

export default {
  data() {
    return {
      memberOf: [],
      available: [],
    };
  },
  props: ["isFacility"],
  components: {
    FacilityListItem,
  },
  mixins: [businessgroupMixin],
  methods: {
    ...mapGetters(["getAssignedFacilities"]),
    getMembers() {
      return this.memberOf;
    },
    addSelected() {
      if (
        this.available.filter((facility) => facility.isActive === true).length >
        0
      ) {
        this.$emit("change");
      }
      this.available
        .filter((facility) => facility.isActive === true)
        .forEach((facility) => {
          this.available.splice(this.available.indexOf(facility), 1);
          facility.isActive = !facility.isActive;
          this.memberOf.push(facility);
        });
    },
    addAll() {
      if (this.available.length > 0) {
        this.$emit("change");
      }
      this.memberOf.push(...this.available);
      this.available = [];
    },
    removeSelected() {
      if (this.isFacility) {
        this.memberOf
          .filter((facility) => facility.isActive === true)
          .forEach((facility) => {
            this.memberOf.splice(this.memberOf.indexOf(facility), 1);
            facility.isActive = !facility.isActive;
            this.available.push(facility);
          });
      } else {
        if (
          this.memberOf.filter((facility) => facility.isActive === true)
            .length > 0
        ) {
          this.$emit("change");
        }
        this.memberOf
          .filter((facility) => facility.isActive === true)
          .forEach((facility) => {
            this.memberOf.splice(this.memberOf.indexOf(facility), 1);
            facility.isActive = !facility.isActive;
            this.available.push(facility);
          });
      }
    },
    removeAll() {
      if (this.isFacility) {
        this.available.push(...this.memberOf);
      } else {
        if (this.memberOf.length > 0) {
          this.$emit("change");
        }
        this.available.push(...this.memberOf);
        this.memberOf = [];
      }
    },
    reset() {
      // clear existing lists
      this.memberOf.splice(0);
      this.available.splice(0);
    },
    fetchFacilities(content) {
      // clear existing lists
      this.memberOf.splice(0);
      this.available.splice(0);
      // fill memberOf by pushing items one after another so vue-reactivity works
      for (let f of content) {
        this.memberOf.push({
          facilityname: `${f.street} ${f.housenumber}, ${f.Location}`,
          facilityid: f.idFacility,
        });
      }
      this.memberOf.forEach((fac) => this.$set(fac, "isActive", false));
      let allFacilities = [];
      for (let f of this.getAssignedFacilities()) {
        allFacilities.push({
          facilityname: `${f.street} ${f.housenumber}, ${f.Location}`,
          facilityid: f.idFacility,
        });
      }

      // build the difference of all groups and those of which the article is already a part of
      this.available = allFacilities.filter((facility1) => {
        return !this.memberOf.some((facility2) => {
          return facility1.facilityid === facility2.facilityid;
        });
      });
      this.available.forEach((fac) => this.$set(fac, "isActive", false));
    },
  },
};
</script>

<style scoped>
.facility-container {
  width: 20vw;
  height: 25vh;
  border: 1px solid grey;
  margin: 1rem;
  overflow-y: auto;
  clear: both;
}

.fs-memberof {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1 {
  margin: 1rem;
  font-size: 1rem;
}

.btn-middle-div {
  max-width: 10vw;
  margin-top: 3rem;
}

div.group-container > div {
  text-align: center;
}

/* On bigger devices, the two containers get closer to each other - distancer divs appear on each side*/
@media (max-width: 1550px) {
  .facilityselector-distancer {
    display: none;
  }
  .btn-middle-div {
    max-width: 15vw;
  }
}

/* for very high resolution - more than 2K (2048 x 1080) */
@media (min-width: 2500px) {
  * {
    font-size: 30px;
  }
  h1 {
    font-size: 30px;
  }
}
</style>
